import { loadStripe } from '@stripe/stripe-js';

// Initialize Stripe with your publishable key
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

// Product IDs for different plans
export const STRIPE_PRODUCTS = {
  PROFESSIONAL: process.env.REACT_APP_STRIPE_PROFESSIONAL_PRODUCT_ID,
};

export const redirectToCheckout = async (priceId) => {
  try {
    const stripe = await stripePromise;
    
    // Create a Checkout Session
    const response = await fetch('/.netlify/functions/create-checkout-session', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        priceId,
        successUrl: `https://build.nailthecost.net/`,
        cancelUrl: `${window.location.origin}/pricing`,
      }),
    });

    const session = await response.json();

    // Redirect to Checkout
    const result = await stripe.redirectToCheckout({
      sessionId: session.id,
    });

    if (result.error) {
      console.error('Error:', result.error);
    }
  } catch (error) {
    console.error('Error:', error);
  }
};

export default stripePromise;
